import React, {useState, useEffect} from 'react';
import {extract, wrapArray} from "../utils";
import {Paginator as PRPaginator} from "primereact/paginator";
import _ from "lodash";

export const Paginator = ({env = 'form',value, render, activeIndex= 0, onPageChange = undefined, extraConfig, ...rest}) => {
    const isTable = env === 'table'
    const {showEmpty = false} = extraConfig
    const useValue = _.flattenDeep(wrapArray(value || [])).filter( el => showEmpty || !!el)

    const [currPage, setCurrPage] = useState({first:activeIndex})
    useEffect( () => {
        if(activeIndex !== currPage.first)setCurrPage({first:activeIndex})
    }, [activeIndex])
    const {location, rows} = extract( {location: 'above', rows: 1}, extraConfig) as any
    const onChange = (e) => {
        setCurrPage(e)
    }
    const pager =
        <PRPaginator  first={currPage.first} onPageChange={onChange}
                  {...extract( {
                      totalRecords: useValue.length, rows: rows, pageLinkSize: undefined, rowsPerPageOptions: undefined,
                      style: undefined, className: undefined, template: isTable ? 'PrevPageLink CurrentPageReport NextPageLink' : undefined, leftContent: undefined, rightContent: undefined,
                      currentPageReportTemplate: isTable ? '{currentPage}/{totalPages}' : undefined,
                  }, extraConfig)}/>
  if(location === 'above'){
      return <>
          {pager}
          {render(useValue[currPage.first], currPage)}
      </>
  }
    return <>
        {render(useValue[currPage.first], currPage)}
        {pager}
    </>

}